import { cn } from '@lib/utils';
import { getCountryFlagCode } from '@utils/country-flag.util';

type CountryFlagSize = 'md' | 'sm';

type CountryFlagProps = {
  className?: string;
  country?: string | null;
  size?: CountryFlagSize;
};

type CountryFlagStyle = React.CSSProperties & {
  '--CountryFlagIcon-height': string;
};

const countryFlagHeights: Record<CountryFlagSize, string> = {
  md: '1rem',
  sm: '0.875rem',
};

export const CountryFlag: React.FC<CountryFlagProps> = (props) => {
  const { className, country, size = 'md' } = props;

  const countryFlagCode = getCountryFlagCode(country);

  if (!countryFlagCode) {
    return null;
  }

  const style: CountryFlagStyle = {
    '--CountryFlagIcon-height': countryFlagHeights[size],
  };

  return (
    <span
      aria-label={`${countryFlagCode} flag`}
      className={cn(
        `flag:${countryFlagCode}`,
        'inline-block shrink-0 rounded-[2px] border border-gray-200 bg-center bg-cover align-middle',
        className,
      )}
      role="img"
      style={style}
    />
  );
};
